<!-- template v.1 -->
<template>
<div class="col py-3 col-md-10">

      <div class="col-md-12" style="padding:0; text-align:center;margin-bottom:15px">
        <h4 class="card-title" style="text-decoration:underline">Reporte de Marcaciones </h4>

      </div>

      <div class="col-md-12" style="padding:0">
      <!-- Profile Image -->
        <div class="card card-info">
          <div class="card-header">
            <h3 class="card-title">Filtro Empleado</h3>
            
          </div>
          <div class="card-body">
              <div class="col-md-12">
                  <div class="col-md-4 form-org">
                      <div class="form-group ">
                  <label class="col-form-label" >
                    Local</label
                  >
                  <select class="form-control"    v-model="Local" @click="CargaReloj()">
                    <option value="-1" >Todos </option>
                    <option v-for="item in Locales" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                <div class="form-group">
                  <label class="col-form-label" >
                    Estado</label
                  >
                  <select class="form-control"  v-model="Estado">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Parametros" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
                
              </div>
              <div class="col-md-4 form-org">
                  <div class="form-group">
                    <label class="col-form-label" >
                      Área</label
                    >
                    <select class="form-control"   v-model="Area">
                      <option value="-1"  >Todos </option>
                      <option v-for="item in Areas" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                      
                    </select>
                  </div>
                  <div class="input-group mb-3">
                      <label class="col-form-label"  style="width: 100%;">
                      Nombres
                      </label>
                      <input type="text" class="form-control" maxlength="50" v-model="Nombres" placeholder="Nombres" >
                      
                  </div>
            
              </div>
              <div class="col-md-4 form-org">
                <div class="input-group">
                  <label class="col-form-label" style="width: 100%;">
                  DNI
                  </label>
                  <input type="number"
                  class="form-control"
                  @keypress="MaxNumber($event)"
                  pattern="^[0-9]+"
                  oninput="validity.valid||(value='');"
                  v-model="DNI"
                  placeholder="XXXXXXXXX" 
                  onwheel="this.blur()"
                  step="1-9"
                  min="0"
                  max="99999999"
                  autocomplete="off">
                </div>

                <div v-if="displayReloj"  class="form-group ">
                  <label class="col-form-label" >
                    Reloj</label
                  >
                  <select class="form-control"    v-model="Reloj">
                    <option value="-1"  >Todos </option>
                    <option v-for="item in Relojes" :key="item" v-bind:value="item.nCodigo" >{{item.sNombre}}</option>
                    
                  </select>
                </div>
            
              </div>
          </div>
          
          <div class="row col-md-12">
            <div class="col-md-4 form-org">
              <div class="input-group">
                <button type="submit" 
                class="btn btn-success" 
                style="width:100%" 
                @click="Buscar()" >
                
                Buscar</button>
              </div>
            </div>
          </div>
          </div>
          <!-- /.card-body -->
        </div>
      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;margin-bottom: 15px;">
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                      <th ><input type="checkbox" id="todos" @click="CheckAll()" v-if="Empleados != ''"></th>
                      <th >Código</th>
                      <th >DNI</th>
                      <th >Nombre Completo</th>
                      <th >Área</th>
                      <th >Reloj</th>
                      <th >Local</th>
                      <th >Estado</th>
                    </tr>
                  </thead>
                  
                  <!-- <tbody v-for="(item, index) in ListaEmpleados.filter(Paginador)"   v-bind:key="item" v-bind:index="index" v-show="(pag - 1) * NUM_RESULTS <= index  && pag * NUM_RESULTS > index"> -->
                     <tbody v-for="(item, index) in ListaEmpleados"   v-bind:key="item" v-bind:index="index" >
                    <!--  <tr v-if="!item.disabled"> -->
                      <tr >
                      <td ><input type="checkbox" v-model="item.nCheck" :checked="(item.nCheck == 1) ? true : false"></td>
                      <td >{{item.nCodigo}}</td>
                      <td >{{item.sDni}}</td>
                      <td >{{item.sNombre}}</td>
                      <td >{{item.sArea}}</td>
                      <td >{{item.sReloj}}</td>
                      <td >{{item.sLocal}}</td>
                      <td >{{item.sEstadoDesc}}</td>
            <!--      <td ><button type="button" class="btn btn-info btn-table" @click="Marcaciones(item)">Ver</button></td> -->


                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPage(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPages" :key="index" v-show="Math.abs(pageNumber - currentPage) <= 5  || pageNumber == totalPages || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPage(pageNumber)" :class="{current: currentPage === pageNumber, last: (pageNumber == totalPages && Math.abs(pageNumber - currentPage) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPage) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
                <!--<nav aria-label="Page navigation" class="text-center;">
                  <ul class="pagination pagination-sm " style="margin-bottom: 0px;float:right">
                    <li class="page-item">
                      <a href="#" aria-label="Previous" class="page-link" v-show="pag != 1" @click.prevent="pag -= 1">
                        <span aria-hidden="true">Anterior</span>
                      </a>
                    </li>
                    <li class="page-item" style="margin-right:0">
                      <a href="#" aria-label="Next" class="page-link" v-show="pag * NUM_RESULTS / Empleados.filter(Paginador).length < 1" @click.prevent="pag += 1">
                        <span aria-hidden="true">Siguiente</span>
                      </a>
                    </li>
                  </ul>
                </nav>
                -->
        </div>

  
            <div class="col-md-12" style="padding:0" >
              <!-- Profile Image -->
              <div class="card card-info">
              <div class="card-header">
                <h3 class="card-title">Filtro Reporte</h3>
                
              </div>
              <div class="card-body">
              <div class="col-md-12">
                  <div class="col-md-4 form-org">
                      <div class="form-group">
                  <label class="col-form-label" >
                    Desde</label
                  >
                   <input type="date" class="form-control" min="1900-01-01"  v-model="FechaRegistroInicio" v-bind:max="Fechainiciomax" @change="FechafinUpdate()" >
                </div>
                 <div class="form-group">
                  <label class="col-form-label" >
                    Hasta</label
                  >
                  <input type="date" class="form-control" max="2099-12-31" v-bind:min="Fechafinmin" @change="FechainicioUpdate()" v-model="FechaRegistroFin">
                </div>
                  </div>
                  <div class="col-md-4 form-org">
                      <div class="input-group">
                            <label class="col-form-label"  style="width: 100%;">
                            Hora Inicio
                            </label>
                            <input type="time" v-model="HoraIngresoRegistro" class="form-control"  min="00:00" max="18:00" required>
                        </div>
                <div class="form-group ">
                            <label class="col-form-label" >
                                Hora Fin</label>
                            <input type="time" v-model="HoraSalidaRegistro" class="form-control" required >
                        </div>
                  </div>
               <div class="col-md-4 form-org">
                <div class="input-group" style="margin-top: 38px;">
                   <button type="submit" 
                   class="btn btn-success" 
                   style="width:100%" 
                   @click="Filtro()" >
                   
                   Buscar</button>
                </div>
                <div class="input-group" style="margin-top: 38px;">
                   <button type="submit" 
                   class="btn btn-info" 
                   style="width:100%" 
                   @click="Exportar()" >
                   
                   Exportar</button>
                </div>
                </div>
              </div>
             <div class="col-md-12 form-org">
                 <div class="form-check">
                    <input class="form-check-input" type="checkbox" v-model="CheckMarcar" id="flexCheckDefault">
                    <label class="form-check-label" for="flexCheckDefault">
                        No considerar si no marcó Entrada o Salida
                    </label>
                    </div>
             </div>
               
               
               
                
              </div>
              <!-- /.card-body -->
            </div>

      </div>
      <div class="col-md-12" style=" margin-top: 15px; float:left;padding:0;margin-bottom: 60px;">
          
          <div class="table-responsive">
           <table class="table table-hover table-responsive"  >
                  <thead  class="tabla-asistencia">       
                    <tr >
                   
                      <th >Código</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Pago H. E.</th>
                      <th >Nombre </th>
                      <th >DNI</th>
                      <th >Área</th>
                      <th >Compañia</th>
                      <th  style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Código SAP</th>
                      <th  style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Nombre Horario</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hora de Ingreso</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hora de Salida</th>
                      <th >Minutos</th>
                      <th >Inicio</th>
                      <th >Fin</th>
                      <th >Turno</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Domingo y Feriado</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Fecha Marcación</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hora de Marcación Entrada</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hora Ingreso Editado</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hora de Marcación Salida</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hora Salida Editado</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Usuario Editor</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Grupo Refrigerio</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Inicio Refrigerio</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Entrada Refrigerio Editado</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Fin Refrigerio</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Fin Refrigerio Editado</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Tiempo Refrigerio</th>
                      <th >Justificación</th>
                      <th >Observación</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Normales</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Refrigerio</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Descuento</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Dom y Fer</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Nocturnas</th>
                      <th >Tardanza</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas temprano</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Extra Totales</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Extra +25%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Extra +35%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Conver Horas Extra Totales</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Conver Horas Extra +25%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Conver Horas Extra +35%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Nocturnas Extra +25%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Conver Horas Nocturnas Extra +25%</th>

                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Nocturnas Extra +35%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Extra Dom y Fer +100%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Conver Horas Extra Dom y Fer +100%</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Horas Compensadas (automáticas)</th>
                      <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Tipo de Permiso</th>
                      <th >Ausencia</th>
                       <th style="text-align: center;text-overflow: ellipsis;white-space: nowrap;">Hrs Desc Sal</th>


                    </tr>
                  </thead>
                  
                  <!-- <tbody v-for="(item, index) in ListaEmpleados.filter(Paginador)"   v-bind:key="item" v-bind:index="index" v-show="(pag - 1) * NUM_RESULTS <= index  && pag * NUM_RESULTS > index"> -->
                     <tbody v-for="(item, index) in ListaReporte"   v-bind:key="item" v-bind:index="index" >
                    <!--  <tr v-if="!item.disabled"> -->
                      <tr >
                     
                      <td >{{item.sCodigo}}</td>
                      <td >{{item.sPagoHE}}</td>
                      <td >{{item.sNombre}}</td>
                      <td >{{item.sDNI}}</td>
                      <td >{{item.sArea}}</td>
                      <td >{{item.sCompania}}</td>
                      <td >{{item.sCodSAP}}</td>
                      <td >{{item.sHorarioNombre}}</td>
                      <td >{{item.sHorarioIngreso}}</td>
                      <td >{{item.sHorarioSalida}}</td>
                      <td >{{item.sHorarioRefriMin}}</td>
                      <td >{{item.sHorarioRefriIng}}</td>
                      <td >{{item.sHorarioRefriSal}}</td>
                      <td >{{item.sTurno}}</td>
                      <td >{{item.sDomingo}}</td>
                      <td >{{item.sMarcFecha}}</td>
                      <td >{{item.sMarcIngresoReal}}</td>
                      <td >{{item.sMarcIngresoEdit}}</td>
                      <td >{{item.sMarcSalidaReal}}</td>
                      <td >{{item.sMarcSalidaEdit}}</td>
                      <td >{{item.sUsuario}}</td>
                      <td >{{item.sRefriGrupoNombre}}</td>
                      <td >{{item.sRefriIngresoReal}}</td>
                      <td >{{item.sRefriIngresoEdit}}</td>
                      <td >{{item.sRefriSalidaReal}}</td>
                      <td >{{item.sRefriSalidaEdit}}</td>
                      <td >{{item.sRefriMin}}</td>
                      <td >{{item.sMarcJustifi}}</td>
                      <td >{{item.sMarcObservac}}</td>
                      <td >{{item.sHorasNormales}}</td>
                      <td >{{item.sHorasRefrigerio}}</td>
                      <td >{{item.sHorasDescuento}}</td>
                      <td >{{item.sHorasDomFer}}</td>
                      <td >{{item.sHorasNocturnas}}</td>
                      <td >{{item.sHorasTardanza}}</td>
                      <td >{{item.sHorasTemprano}}</td>
                      <td >{{item.sHETotales}}</td>
                      <td >{{item.sHE25}}</td>
                      <td >{{item.sHE35}}</td>
                      <td >{{item.numHETotales}}</td>
                      <td >{{item.numHE25}}</td>
                      <td >{{item.numHE35}}</td>
                      <td >{{item.sHE25Noct}}</td>
                      <td >{{item.numHE25Noct}}</td>
                      <td >{{item.sHE35Noct}}</td>
                      <td >{{item.sHEDomFer}}</td>
                      <td >{{item.numHEDomFer}}</td>
                      <td >{{item.sHorasCompensadas}}</td>
                      <td >{{item.sTipoPermiso}}</td>
                      <td >{{item.sAusencia}}</td>
                      <td >{{item.sHorasDescuento_Sal}}</td>


            <!--      <td ><button type="button" class="btn btn-info btn-table" @click="Marcaciones(item)">Ver</button></td> -->


                    
                      
                    </tr>

                    
                  </tbody>
                 
                   
         
                </table>
                </div>
                <div style="display: flex;align-items: start;  " >
                    <button  @click="setPageReporte(1)" type="button" style="border-radius: 0px;" class="btn btn-primary" >Primero</button>
                    <nav aria-label="Page navigation example" style="    background: transparent !important;">
                      <ul class="pagination">
                        <li class="page-item" v-for="(pageNumber, index) in totalPagesReporte" :key="index" v-show="Math.abs(pageNumber - currentPageReporte) <= 5  || pageNumber == totalPagesReporte || pageNumber == 0" >
                            <a class="page-link" style="cursor:pointer" @click="setPageReporte(pageNumber)" :class="{current: currentPageReporte === pageNumber, last: (pageNumber == totalPagesReporte && Math.abs(pageNumber - currentPageReporte) > 3), first:(pageNumber == 0 && Math.abs(pageNumber - currentPageReporte) > 3)}">
                                {{ pageNumber }} 
                            </a>
                        </li>
                    </ul>
                    </nav>
                </div>
              
      </div>
</div>    
</template>
<script>
import XLSX from "xlsx";
import XLSTYLE from "xlsx-style";
import { saveAs } from "file-saver";
export default {
     props: ["content"],

  data: function () {
    return {
      Locales:[],
      Areas:[],
      Relojes:[],
      Parametros:[],
      Local:-1,
      Area:-1,
      Reloj:-1,
      Estado:1,
      alertax:false,
      Fechafinmin : '1900-01-01',
      Fechainiciomax : '2099-12-31',
      FechaRegistroInicio : '',
      FechaRegistroFin : '',
      HoraIngresoRegistro : '00:00',
      HoraSalidaRegistro : '23:59',
      CheckMarcar : false,
      DNI:"",
      Nombres:"",
      Empleados:[],
      ListaEmpleados:[],
      Reporte:[],
      ListaReporte:[],
      DetalleReporte:[],
      Data:[],
      itemsPageDefaultReporte : 10,
      resultCountReporte: 0,
      currentPageReporte: 0,
      itemsPageDefault : 10,
      resultCount: 0,
      currentPage: 0,
      displayReloj: false
      

      
    };
  },
  computed: {
        totalPages: function() {
          return Math.ceil(this.resultCount / this.itemsPageDefault)
        },
        totalPagesReporte: function() {
          return Math.ceil(this.resultCountReporte / this.itemsPageDefaultReporte)
        }
  },
  mounted(){
    this.content.login = false;
    this.content.sistema = true;

    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarLocales?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Locales = response.data.oListaLocales;
        })
    
    this.axios
        .get(gestion + "/ListarAreas?nCodigo=-1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Areas = response.data.oListaAreas;
        })
    this.axios
        .get(gestion + "/ListarParametrosHijos?nCodigo=1", {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Parametros = response.data.oListaParametros;
        })
    
  },
  methods: {
    


    Exportar() {
  
          const wb = { SheetNames: [], Sheets: {} };
          const ws_name = "Reporte";
          var tmpPedidos = [];
          var tmpMerge = [];
          var positionCell = 0;
          var cellsStyle = [];
          var tmpPedido = [];

           
            tmpPedido = [];
            
            for (var i=0; i < 45; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)
     
            tmpPedido = [];
            tmpPedido.push("Empresa:");
            tmpPedido.push(this.DetalleReporte.sEmpresa);
            for (var i=0; i < 43; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)

            tmpPedido = [];
            
            tmpPedido.push("RUC:");
            tmpPedido.push(this.DetalleReporte.sRUC);
            for (var i=0; i < 43; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)

            tmpPedido = [];
            tmpPedido.push("Fecha :")
            tmpPedido.push(this.DetalleReporte.sFecha);
            for (var i=0; i < 43; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)

            tmpPedido = [];
            tmpPedido.push("Rango de Reporte:");
            tmpPedido.push(this.DetalleReporte.sRango);
            for (var i=0; i < 43; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)
            tmpPedido = [];
            
            for (var i=0; i < 45; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)
            tmpPedido = [];
            
            for (var i=0; i < 45; i++){
            tmpPedido.push(null)   
            }
            tmpPedidos.push(tmpPedido)

            tmpPedido = []
          tmpPedido.push("Código");
          tmpPedido.push("Pago H. E.");
          tmpPedido.push("Nombre");
          tmpPedido.push("DNI");
          tmpPedido.push("Área");
          tmpPedido.push("Compañia");
          tmpPedido.push("Código SAP");
          tmpPedido.push("Nombre Horario");
          tmpPedido.push("Hora de Ingreso");
          tmpPedido.push("Hora de Salida");
          tmpPedido.push("Minutos");
          tmpPedido.push("Inicio");
          tmpPedido.push("Fin");
          tmpPedido.push("Turno");
          tmpPedido.push("Domingo y Feriado");
          tmpPedido.push("Fecha Marcación");
          tmpPedido.push("Hora de Marcación Entrada");
          tmpPedido.push("Hora Ingreso Editado");
          tmpPedido.push("Hora de Marcación Salida");
          tmpPedido.push("Hora Salida Editado");
          tmpPedido.push("Usuario Editor");
          tmpPedido.push("Grupo Refrigerio");
          tmpPedido.push("Inicio Refrigerio");
          tmpPedido.push("Entrada Refrigerio Editado");
          tmpPedido.push("Fin Refrigerio");
          tmpPedido.push("Fin Refrigerio Editado");
          tmpPedido.push("Tiempo Refrigerio");
          tmpPedido.push("Justificación");
          tmpPedido.push("MSJ ASIS");
          tmpPedido.push("Horas Normales");

          tmpPedido.push("Horas Descuento");
          tmpPedido.push("Horas Dom y Fer");
          tmpPedido.push("Horas Nocturnas");
          tmpPedido.push("Tardanza");
          tmpPedido.push("Horas temprano");
          tmpPedido.push("Horas Extra Totales");
          tmpPedido.push("Horas Extra +25%");
          tmpPedido.push("Horas Extra +35%");
          tmpPedido.push("Conver Horas Extra Totales");
          tmpPedido.push("Conver Horas Extra +25%");
          tmpPedido.push("Conver Horas Extra +35%");
          tmpPedido.push("Horas Nocturnas Extra +25%");
          tmpPedido.push("Conver Horas Nocturnas Extra +25%");
          tmpPedido.push("Horas Nocturnas Extra +35%");
          tmpPedido.push("Horas Extra Dom y Fer +100%");
          tmpPedido.push("Conver Horas Extra Dom y Fer +100%");
          tmpPedido.push("Horas Fuera Horario");
          tmpPedido.push("Incidencia");
          tmpPedido.push("Observaciones");
          tmpPedido.push("Origen");
          tmpPedido.push("Hora Desc Sal");
          
        
          tmpPedidos.push(tmpPedido);
          if (this.Reporte.length > 0) {
            this.Reporte.forEach((ped) => {
             
                const tmpdetPedido = [];

                tmpdetPedido.push(ped.sCodigo);
                tmpdetPedido.push(ped.sPagoHE);
                tmpdetPedido.push(ped.sNombre);
                tmpdetPedido.push(ped.sDNI);
                tmpdetPedido.push(ped.sArea);
                tmpdetPedido.push(ped.sCompania);
                tmpdetPedido.push(ped.sCodSAP);
                tmpdetPedido.push(ped.sHorarioNombre);
                tmpdetPedido.push(ped.sHorarioIngreso);
                tmpdetPedido.push(ped.sHorarioSalida);
                tmpdetPedido.push(ped.sHorarioRefriMin);
                tmpdetPedido.push(ped.sHorarioRefriIng);
                tmpdetPedido.push(ped.sHorarioRefriSal);
                tmpdetPedido.push(ped.sTurno);
                tmpdetPedido.push(ped.sDomingo);
                tmpdetPedido.push(ped.sMarcFecha);
                tmpdetPedido.push(ped.sMarcIngresoReal);
                tmpdetPedido.push(ped.sMarcIngresoEdit);
                tmpdetPedido.push(ped.sMarcSalidaReal);
                tmpdetPedido.push(ped.sMarcSalidaEdit);
                tmpdetPedido.push(ped.sUsuario);
                tmpdetPedido.push(ped.sRefriGrupoNombre);
                tmpdetPedido.push(ped.sRefriIngresoReal);
                tmpdetPedido.push(ped.sRefriIngresoEdit);
                tmpdetPedido.push(ped.sRefriSalidaReal);
                tmpdetPedido.push(ped.sRefriSalidaEdit);
                tmpdetPedido.push(ped.sRefriMin);
                tmpdetPedido.push(ped.sMarcJustifi);
                tmpdetPedido.push(ped.sMarcObservac);
                tmpdetPedido.push(ped.sHorasNormales);

                tmpdetPedido.push(ped.sHorasDescuento);
                tmpdetPedido.push(ped.sHorasDomFer);
                tmpdetPedido.push(ped.sHorasNocturnas);
                tmpdetPedido.push(ped.sHorasTardanza);
                tmpdetPedido.push(ped.sHorasTemprano);
                tmpdetPedido.push(ped.sHETotales);
                tmpdetPedido.push(ped.sHE25);
                tmpdetPedido.push(ped.sHE35);
                tmpdetPedido.push(ped.numHETotales);
                tmpdetPedido.push(ped.numHE25);
                tmpdetPedido.push(ped.numHE35);
                tmpdetPedido.push(ped.sHE25Noct);
                tmpdetPedido.push(ped.numHE25Noct);
                tmpdetPedido.push(ped.sHE35Noct);
                tmpdetPedido.push(ped.sHEDomFer);
                tmpdetPedido.push(ped.numHEDomFer);
                tmpdetPedido.push(ped.sHorasCompensadas);
                tmpdetPedido.push(ped.sTipoPermiso);
                tmpdetPedido.push(ped.sAusencia);
                tmpdetPedido.push(ped.sOrigen);
                tmpdetPedido.push(ped.sHorasDescuento_Sal);
               
               

                tmpPedidos.push(tmpdetPedido);
            
            });  
          }
        

          var sheet = XLSX.utils.aoa_to_sheet(tmpPedidos);
            



          sheet["!merges"] = tmpMerge;
          sheet["A2"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
        };
        sheet["A3"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
        };
        sheet["A4"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
        };
        sheet["A5"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
        };
          var colum = ["A","B","C","D","E","F","G","H","I",
          "J","K","L","M","N","O","P","Q","R",
          "S","T","U","V","W","X","Y","Z","AA",
          "AB","AC","AD","AE","AF","AG","AH","AI","AJ",
          "AK","AL","AM","AN","AO","AP","AQ","AR","AS","AT","AU","AV","AW","AX","AY"]
          for(var i = 0;  i < colum.length;i++){
         
          sheet[colum[i]+"8"].s = {
          fill :{
          fgColor : {
          rgb: "800080",
          },
          
          },
          font: {
          sz: 13,
          color: {
            rgb: "FFFFFF",
          },
          },
          alignment: {
          horizontal: "center",
          vertical: "center",
          wrap_text: true,
          },
          border: {
          top: {
            style: "thin",
          },
          bottom: {
            style: "thin",
          },
          left: {
            style: "thin",
          },
          right: {
            style: "thin",
          },
        },
      };   
          }

      sheet["!cols"] = [
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 300,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 150,
        },
        {
          wpx: 80,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 300,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 300,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 170,
        },
        {
          wpx: 150,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 300,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 300,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 200,
        },
        {
          wpx: 150,
        },
        {
          wpx: 150,
        },
        {
          wpx: 150,
        },
        
       
      ]; 
          var style_default = {
            font: { sz: 13, bold: true },
            alignment: {
              horizontal: "center",
              vertical: "center",
              wrap_text: true,
            },
          }

          wb.SheetNames.push(ws_name);
         wb.Sheets[ws_name] = sheet; 
        const wbout = XLSTYLE.write(wb, {
            type: "binary",
            bookSST: true,
            bookType: "xlsx",
            cellStyles: true,
          });
          saveAs(
            new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }),
            "Reporte.xlsx"
          )
  
    },
    s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },
    Filtro(){
    this.Data = this.Empleados.filter((item)=>{
        return item.nCheck == true
        });
     
        var codigocheck = "";
        this.Data.forEach((el) => {
              codigocheck +=
                ","+
                el.nCodigo;
                
        });
        const datacheck = codigocheck.substring(1);
        console.log(datacheck)
        var fechaini = this.FechaRegistroInicio+' '+this.HoraIngresoRegistro;
        var fechafin = this.FechaRegistroFin+' '+this.HoraSalidaRegistro;
        const Check = (this.CheckMarcar) ? 1 : 0;
        console.log(Check)
        console.log(fechaini)
        console.log(fechafin)
        let gestion = this.$store.state.menu;
   
        this.axios
        .get(gestion + "/CargarRepMarcaciones?sCodigos="+datacheck+"&sFechaInicio="+fechaini+"&sFechaFin="+fechafin+"&nCheck="+Check, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.DetalleReporte = response.data.oCabecera;
          this.Reporte = response.data.oListaDetalle;
          const countUser = this.Reporte.filter(resp => !resp.disabled);
          this.resultCountReporte = countUser.length;
          this.currentPageReporte = 0;
          if (this.currentPageReporte >= this.totalPagesReporte) {
                this.currentPage = this.totalPagesReporte
          }
          var index = this.currentPageReporte * this.itemsPageDefaultReporte;      
          this.ListaReporte = this.Reporte.slice(index,index+this.itemsPageDefaultReporte);
        })

        
    },
    CheckAll(){
    if(document.getElementById("todos").checked){
    var check = true
    for (var i = 0; i < this.Empleados.length; i++) {
      this.Empleados[i].nCheck = check;
    }
    }
    else {
    var check = false
    for (var i = 0; i < this.Empleados.length; i++) {
      this.Empleados[i].nCheck = check;
    }
    }
    },
    selectRow(item){
            if (item.sCheck == 1) {
                item.sCheck = 0;
            }else{
                item.sCheck = 1;
            }  
            
    },
    FechainicioUpdate(){
    this.Fechainiciomax = this.FechaRegistroFin;
    },
    FechafinUpdate(){
    this.Fechafinmin = this.FechaRegistroInicio;
    },
    Buscar(){
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarEmpleados?nLocal="+this.Local+"&nReloj="+this.Reloj+
        "&nArea="+this.Area+"&nEstado="+this.Estado+"&sNombre="+this.Nombres+"&sDni="+this.DNI, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Empleados = response.data.oListaEmpleados;
          const countUser = this.Empleados.filter(resp => !resp.disabled);
          this.resultCount = countUser.length;
          this.currentPage = 0;
          if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
          }
          var index = this.currentPage * this.itemsPageDefault;      
          this.ListaEmpleados = this.Empleados.slice(index,index+this.itemsPageDefault);

          
        })

    
    },
     setPage: function(pageNumber) {
            this.currentPage = pageNumber;
 
        
            if (this.currentPage >= this.totalPages) {
                this.currentPage = this.totalPages
                
            }
            var index = (this.currentPage - 1) * this.itemsPageDefault;
            this.ListaEmpleados = this.Empleados.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefault);
        },
        setPageReporte: function(pageNumberReporte) {
            this.currentPageReporte = pageNumberReporte;
 
        
            if (this.currentPageReporte >= this.totalPagesReporte) {
                this.currentPageReporte = this.totalPagesReporte
                
            }
            var index = (this.currentPageReporte - 1) * this.itemsPageDefaultReporte;
            this.ListaReporte = this.Reporte.filter(resp => !resp.disabled ).slice(index, index + this.itemsPageDefaultReporte);
        },
    CargaReloj(){
    const Reloj = this.Local;
    let gestion = this.$store.state.menu;
    this.axios
        .get(gestion + "/ListarRelojes?nCodigo="+ Reloj, {
          headers: {
            Authorization: "Bearer " + localStorage.token,
          },
        })
        .then((response) => {
          this.Relojes = response.data.oListaRelojes;
        })
    },
    MaxNumber : function (evt) {
          evt = (evt) ? evt : window.event;
          const value = evt.target.value;
          var charCode = (evt.which) ? evt.which : evt.keyCode;
          
           if ( value.length < 8 && (charCode >= 48 && charCode <= 57) ) {
            return true;
          }else{
          this.$swal({
          toast: true,
          timer:3000,
          position: 'top',
          showConfirmButton: false,
          title: 'Su DNI debe contar con 8 dígitos',
          icon: 'error',
          
          });
            evt.preventDefault();
          }
    },
    
   
        

  },
}
</script>

<style scoped>
  .btn-info,.btn-info:hover, .btn-info:active{
    color: #ffffff !important;
  }
</style>

